export default "__VITE_ASSET__Tpg8Mgsv__"